import React, { useContext } from "react";
import GameModeContext from "./context/GameMode";
import GameScoreContext from "./context/GameScore";
import ModeButton from "./ModeButton";
import "./Gamemode.css";

const Gamemode = (props) => {
  const GameMode = useContext(GameModeContext);
  const GameScore = useContext(GameScoreContext);
  const modeList = [7, 8, 9];

  const modeChange = (e) => {
    window.ysdk.features.GameplayAPI.stop();
    window.ysdk.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          window.ysdk.features.GameplayAPI.start();
          GameMode.actions.setGamemode(Number(e.target.value));
          GameScore.actions.setGameScore(0);
          props.onClick();
        },
        onError: function (error) {},
      },
    });
  };

  const modeButton = modeList.map((mode) => {
    return mode == GameMode.state.gamemode ? (
      <ModeButton
        key={mode.toString()}
        mode={mode}
        isActive={true}
        onClick={modeChange}
      />
    ) : (
      <ModeButton
        key={mode.toString()}
        mode={mode}
        isActive={false}
        onClick={modeChange}
      />
    );
  });

  return <ul className="button-mode">{modeButton}</ul>;
};

export default React.memo(Gamemode);
